<template>
  <div class="content">
    <div class="search-box">
      <div class="search-box-sec left-justifying">
        <img :src="require('../../assets/'+appTheme+'/search_icon.png')" alt="" />
        <input class="searchInput" @keyup.enter="searchClick" v-model="searchValue" placeholder="搜一搜" type="search" />
      </div>
    </div>
    <van-tabs title-active-color="#F23926" background="#FDD80D" line-height="0" style="margin-top: -1.33333vw;" title-inactive-color="#282828">
      <van-tab v-for="(item,index) in navList" :title="item.name" :key="index" @click="onClick">
        <div class="classify-box">
          <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="(image, index) in banner" :key="index"><img class="cover-img" :src="require('../../assets/'+appTheme+'/img.png')" /></van-swipe-item>
          </van-swipe>
          <div class="shop-box">
            <div class="shop-list">
              <div class="shop-item" v-for="(item,index) in list" :key="index" @click="goDes">
                <div class="shop-item-box">
                  <img class="shop-img" src="https://img01.yzcdn.cn/vant/apple-2.jpg" alt="">
                  <div class="title"> <div class="tag">￥1</div> {{item.title}}</div>
                  <div class="price-box justify-align">
                    <div class="price">￥{{item.price}}</div>
                    <img :src="require('../../assets/'+appTheme+'/share_icon.png')" alt="" />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <div class="null-box"></div>
  </div>
</template>


<script>
export default {
  name: "list",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      activeNav: 0,
      searchValue: '',
      active: 0,
      list: [],
      banner: [{},{}, {}, {}],
      curr: 0,
      navList: [{name: '￥1精品'},{name: '灯饰照明'},{name: '锁具五金'},{name: '日用食品'},{name: '厨房卫浴'},{name: '板材家具'}],
      category_id: ''
    }
  },
  created() {
    var id = this.$route.query.id
    this.category_id = id
    // this.getCategory()
    this.getGoodList()
  },
  methods:{
    async getCategory () {
      const res = await this.$Http.getCategoryList()
      if (res.code == 200){
        console.log('res',res)
        this.navList = res.data
        this.getGoodList()
      } else {
        this.$toast(res.message)
        this.$router.push('/');
      }
    },
    async getGoodList () {
      var data ={
        category_id: this.category_id,
        page: 1
      }
      const res = await this.$Http.getGoodsList(data)
      if (res.code == 200){
        console.log('res',res)
        this.list = res.data.data
        console.log(this.list)
      } else {
        this.$toast(res.message)
        this.$router.push('/');
      }
    },
    async moreList(){
      var data ={
        category_id: this.category_id,
        page: this.page
      }
      const res = await this.$Http.getGoodsList(data)
      if (res.code == 200){
        console.log('res',res)
        this.list.push(res.data.data);
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= res.data.total) {
          this.finished = true;
        }
      } else {
        this.$toast(res.message)
        this.$router.push('/');
      }
    },
    goDes(){
      this.$router.push({path:'/goodDetails',query: {id:'10387'}})
    },
    onClick(name, title){
      console.log(title)
    },
    searchClick(){
      console.log(this.searchValue)
      this.$router.push({path:'/searchList',query: {value:this.searchValue}})
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.van-tab--active {
  font-weight: bold;
  color: #F23926;font-size: 32px;
}
.my-swipe{
  width: 695px;margin: 24px auto 12px;
  img{
    width: 100%; height: 264px;display: block;
  }
}
.my-swipe .van-swipe-item {
  height: 264px;
}
.search-box{
  padding: 34px 42px 34px 27px;
  background: #FDD80D;
  img{
    width: 22px;height: auto;display: inline-block;
  }
  .search-box-sec{
    width: 680px;
    height: 60px;
    line-height: 60px;color: #8C8C8C;font-size: 24px;
    background: #FFFFFF;
    opacity: 0.63;
    border-radius: 30px;text-align: left;padding-left: 28px;
    img{
      width: 34px;height: auto;display: inline-block;
    }
    .searchInput{
      height: 60px;
      line-height: 60px;width: 500px;margin-left: 10px;border: none;background: none;color: #282828;font-size: 28px;
    }
  }
}
.shop-box{
  font-size: 28px;
  .shop-list{
    padding: 0 24px;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    .shop-item{
      width: 50%;text-align: center;margin-bottom: 20px;
      .shop-item-box{
        margin: 16px 0;background: #ffffff;border-radius: 10px;
      }
      .shop-img{
        width: 100%;
        height: 343px;
      }
      .title{
        margin-top: 30px;font-size: 28px;font-weight: bold;
        color: #000000;text-align: left;padding: 0 10px;
        .tag{
          display: inline-block;background: #F23926;
          border-radius: 5px;padding: 0 10px;font-size: 18px;color: #FFFFFF;font-weight: bold;
        }
      }
      .price-box{
        padding: 15px 10px 15px;
        .price{
          font-weight: bold;
          color: #F23926;font-size: 32px;
        }
        img{
          width: 50px;
          height: 50px;
        }
      }
    }
  }
}
.shop-box .shop-list .shop-item:nth-child(odd) .shop-item-box{
  margin-right: 20px;
}
.shop-box .shop-list .shop-item:nth-child(even) .shop-item-box{
  //margin-left: 20px;
}
</style>
